import { getLatAndLongFromCookies } from '@/src/lib/actions/getCookies';
import HttpCLient from '@/src/lib/utils/httpClient';
import { BasicProductDataResponse } from '@/src/types/catalog';

type Store = {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  logoURL: string;
};

type params = {
  SearchKey: string;
  latitude?: number;
  longitude?: number;
  BranchIds?: string[];
};

export type ProductItem = {
  integrationId: string;
  arabicName?: string;
  englishName?: string;
  arabicDescription?: string;
  englishDescription?: string;
  price?: number;
  originalPrice?: number;
  isSoldOut?: boolean;
  returnable?: boolean;
  defaultImage?: string;
  isHaveValidDiscount?: boolean;
  branchId?: string;
  storeName?: string;
  branchName?: string;
  storeId?: string;
};

interface PopularBranch {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  logoURL: string;
  isExpress: boolean;
  isNewStore: boolean;
  acceptsBuyNowPayLater: boolean;
  industries: any[]; // You can define a more specific type for industries if needed
}
export interface IPopularStores {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  store: PopularBranch;
  distance: number;
  isOpen: boolean;
  isExpress: boolean;
  isNewStore: boolean;
  acceptsBuyNowPayLater: boolean;
  orderTypes: number[];
  countryId: number;
}
class SerchDialog extends HttpCLient {
  fetchProducts = async (keyword: string) => {
    const { latitude, longitude } = await getLatAndLongFromCookies();
    if (!keyword?.trim() || keyword?.length <= 0) return [];

    const data = {
      SearchTerm: keyword.trim(),
      Latitude: latitude,
      Longitude: longitude,
      Radius: '25',
    };

    const response = await this.post<ProductItem[]>(
      'catalog/products/discovery/search',
      {
        ...data,
      },
      {
        next: {
          tags: ['searchProducts'],
        },
      },
    );

    if (!response) return [];

    return response;
  };

  fetchStores = async (q: string = '', page: string = '1', pageCount: string = '100') => {
    const data = {
      q: q,
      page: page,
      pageCount: pageCount,
    };

    return this.get<Store[]>('core/branches/nearby', data, {
      next: {
        tags: ['searchStores'],
      },
    });
  };

  fetchRelatedStores = async (params: params) => {
    const { latitude, longitude } = await getLatAndLongFromCookies();
    const data = {
      ...params,
      latitude: latitude,
      longitude: longitude,
    };

    return this.post<Store[]>('branches/searchStores', data, {
      next: {
        tags: ['searchRelatedStores'],
      },
    });
  };

  fetchPoplarStores = async () => {
    const response = await this.get<IPopularStores[]>(
      'branches/trending',
      {},
      {
        next: { tags: ['popularStores'] },
      },
    );
    return response;
  };

  fetchProductsTranding = async () => {
    const response = await this.get<BasicProductDataResponse[]>(
      'products/trending',
      {},
      {
        next: { tags: ['trendingProducts'] },
      },
    );
    return response;
  };
}

export const searchService = new SerchDialog();
